// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { history, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';

// import global components
import Base from '../../../global/components/BaseComponent.js.jsx';

// import actions
// import page components
import StudyLayout from '../../study/components/StudyLayout.js.jsx';

// import releaseNotes from '../../../releaseNotes.json'
import releaseNotes from '../../../global/utils/releaseNotes'; // in util so that we can make it database backed at some point in the future

class ReleaseNotes extends Base {
  constructor(props, context) {
    super(props);
    // this._bind()
  }

  render() {
    return(
      <StudyLayout>
        <Helmet
          title={"Release Notes | Pro-ficiency"}
        />
        <div className="flex">
          <section className="section">
            <div className="yt-container">
              <h1> Release Notes </h1>
              <hr/>
              <h3>Version: {appVersion}</h3>
              {/* <div>{releaseNotes[appVersion]}</div> */}
              <div dangerouslySetInnerHTML={{__html: releaseNotes.getNotesByVersion(appVersion)}}></div>

            </div>
          </section>
        </div>
      </StudyLayout>
    )
  }
}

ReleaseNotes.propTypes = {
  dispatch: PropTypes.func.isRequired
}

const mapStoreToProps = (store) => {
  return {
    currentUser: store.user.loggedIn.user
  }
}

export default withRouter(
  connect(
    mapStoreToProps
  )(ReleaseNotes)
);



// WEBPACK FOOTER //
// modules/static/views/ReleaseNotes.js.jsx